import { createApp } from 'vue';
import { maxLicenseCount, resetLicenseCount } from '../../Shared/licenseCountValidation';

const app = createApp({
    data() {
        return {
        isBrowsingProductModal: false,
        attributeFormat: "",
        attributeFormatId: "",
        attributeBrowsingLicenseTypeId: "",
        attributeLicenseType: "",
        attributeLicenseTypeId: "",
        browsingDurationInMinutes: null,
        attributeLanguageId: "",
        attributeLanguageType: "",
        licenseCount: 1,
        selectedCollectionItemLanguageId: 0,
        addingError: "",
        productId: null,
        isAnonymousUser: false,
        selectedCountryId: 0,
        selectedStateId: 0,
        hasStates: false,
        productStateCache: {}
        };
    },
    methods: {
        findElement: function (selector) {
            return $('#product-details-page').find(selector);
        },
        openProductModal: function (productId) {
            this.productId = productId;
            
            if (this.productStateCache[productId]) {
                const cache = this.productStateCache[productId];
                this.attributeFormat = cache.attributeFormat;
            } else {
                this.attributeFormat = "";
            }

            this.isBrowsingProductModal = false;
            this.attributeBrowsingLicenseTypeId = "";
            this.browsingDurationInMinutes = null;
            this.selectedCountryId = 0;
            this.selectedStateId = 0;
        },
        openBrowsingProductModal: function (productId, attributeFormatId, isAnonymousUser) {
            this.productId = productId;
            this.attributeFormat = 'PdfFormat';
            this.isBrowsingProductModal = true;
            this.attributeFormatId = attributeFormatId;
            this.attributeLicenseTypeId = "";
            this.isAnonymousUser = isAnonymousUser;
        },
        setAttributeLanguage: function(selectedLanguage){
            this.attributeLanguageType = selectedLanguage;
        },
        setAttributeFormat: function(selectedFormat) {
            this.attributeFormat = selectedFormat;
            this.attributeLicenseType = "";
            this.attributeLicenseTypeId = "";
        },
        setAttributeLicense: function (selectedLicense, attributeBrowsingLicenseTypeId) {
            this.attributeLicenseType = selectedLicense;

            if(attributeBrowsingLicenseTypeId != null)
            {
                this.attributeBrowsingLicenseTypeId = attributeBrowsingLicenseTypeId;
            }
        },
        incrementCounter: function () {
            this.licenseCount += 1;
        },
        decrementCounter: function () {
            this.licenseCount -= 1;
        },
        calculatePrice: function () {
            var quantityInput = this.findElement("#license-count-input");
            quantityInput.val(this.licenseCount);
            quantityInput.trigger('change');
        },
        setCollectionItemLanguage: function (language) {
            this.selectedCollectionItemLanguageId = language;
        },
        addItemToCollection: function (productId) {
            var collectionData = new FormData();
            collectionData.append('productId', productId);
            collectionData.append('language', this.selectedCollectionItemLanguageId);
            var self = this;

            $.ajax({
                type: 'POST',
                url: 'collection/AddItemToCollection',
                data: collectionData,
                processData: false,
                contentType: false,
                cache: false,
                success: function() {
                    self.findElement('#add-collection-modal').modal('hide');
                    self.findElement('#item-added-to-collection-modal').modal('show');
                },
                error: function(error) {
                    self.findElement('#add-collection-modal').modal('hide');
                    self.findElement('#collection-error-modal').modal('show');
                }
            });
        },
        resetAttributeValues: function () {
            this.attributeFormat = ""
            this.attributeFormatId = ""
            this.attributeLicenseType = ""
            this.attributeLicenseTypeId = ""
            this.attributeLanguageId = ""
            this.licenseCount = 1
            $('#attribute-modal--error .content').remove();
        },
        addItemToMonitoring: function (productId) {
            var monitoringData = new FormData();
            monitoringData.append('productId', productId);
            var self = this;

            $.ajax({
                type: 'POST',
                url: 'monitoringservice/addtomonitoring',
                data: monitoringData,
                processData: false,
                contentType: false,
                cache: false,
                success: function() {
                    self.findElement('#item-added-to-monitoring-modal').modal('show');
                },
                error: function(error) {
                    self.findElement('#monitoring-error-modal').modal('show');
                }
            });
        },
        validateBrowsingServiceOrShowError: function (event, browsingDurationInMinutesErrorText, languageErrorText, countryErrorText, stateErrorText, unableToConfirmErrorText) {
            $('#attribute-modal--error .content').remove();
            
            let errorMessages = [];
            if (!this.browsingDurationInMinutes) {
                errorMessages.push(browsingDurationInMinutesErrorText);
            }
            
            if (!this.attributeLanguageType) {
                errorMessages.push(languageErrorText);
            }
            
            if (this.selectedCountryId === 0) {
                errorMessages.push(countryErrorText);
            } else {
                this.selectedStateId = parseInt(document.getElementById("selectedStateId").value);
                if (this.hasStates && this.selectedStateId === 0) {
                    errorMessages.push(stateErrorText);
                } else {
                    $.ajax({
                        cache: false,
                        async: false,
                        type: "GET",
                        url: '/anonymouscustomerbrowsingservice/checkcountryselectionbasedonclientipaddress',
                        data: { "selectedCountryId": this.selectedCountryId, "selectedStateId": this.selectedStateId  },
                        success: function(data) {
                            if(!data.Success){
                                errorMessages.push(unableToConfirmErrorText);
                            }
                        }
                    });
                }
            }
            
            if (errorMessages.length > 0) {
                displayBarNotification(errorMessages, 'error', 0);
                event.preventDefault();
            }
        },
        saveProductState: function () {
            if (this.productId) {
                this.productStateCache[this.productId] = {
                    attributeFormat: this.attributeFormat
                };
            }
        }
    },
    created: function () {
        var self = this;
        document.addEventListener('product-states-changed', function (e) {
            self.hasStates = e.detail.hasStates;
        });
    },
    watch: {
        data(val) {
          this.selectedStateId = val.selectedStateId
        },
        selectedCountryId: function (){
            this.selectedStateId = 0
        },
        attributeFormat: function () {
            this.attributeLicenseType = "";
            this.licenseCount = 1;
            this.licenseGroup = false;
            this.countInput = false;
        },
        attributeLicenseType: function () {
            if (this.attributeLicenseType === "MultiUserLicense") {
                this.licenseCount = 2;
            } else {
                this.licenseCount = 1;
            }
        },
        licenseCount: function () {
            var minCount = this.attributeLicenseType === "MultiUserLicense" ? 2 : 1;
            var validCount = resetLicenseCount(this.licenseCount, minCount);
            if (validCount !== this.licenseCount) {
                this.licenseCount = validCount;
                return;
            }
            this.calculatePrice();
        }
    },
    computed: {
        maxLicenseCount: function () {
            return maxLicenseCount;
        },
        showAttributeLicenseGroup: function () {
            var licenseGroup = false;

            if (this.attributeFormat === "PdfFormat" || this.attributeFormat === "PdfRedlineFormat") {
                licenseGroup = true;
            }
            return licenseGroup;
        },
        showLicenseCountInput: function () {
            var countInput = false;

            if (this.attributeFormat === "PaperFormat" || this.attributeLicenseType === "MultiUserLicense") {
                countInput = true;
            }
            return countInput;
        }
    }
});

window.vm = app.mount('#product-details-page'); // vm.resetAttributeValues needs window.vm
